var _circle, _circle2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlagNlCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 11,
  fill: "#000",
  stroke: "#fff",
  strokeLinecap: "square",
  strokeWidth: 2
})), /*#__PURE__*/React.createElement("mask", {
  id: "a",
  width: 24,
  height: 24,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 11,
  fill: "#fff",
  stroke: "#fff",
  strokeLinecap: "square",
  strokeWidth: 2
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#BD2B38",
  d: "M25.417.003H-1.72c-.74.003-1.45.33-1.97.908a3.24 3.24 0 0 0-.81 2.174v4.962h32.696V3.085a3.24 3.24 0 0 0-.81-2.174c-.52-.578-1.23-.905-1.97-.908"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FCFBFA",
  d: "M-4.5 16.12h32.696V7.983H-4.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#283264",
  d: "M-4.5 21.044c0 .81.293 1.588.814 2.161.522.574 1.229.895 1.966.895h27.137c.737 0 1.444-.322 1.965-.895s.814-1.35.814-2.161V16.12H-4.5z"
}))));
export { SvgFlagNlCircle as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxjaXJjbGUgY3g9IjEyIiBjeT0iMTIiIHI9IjExIiBmaWxsPSJibGFjayIgc3Ryb2tlPSJ3aGl0ZSIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0ic3F1YXJlIiAvPgogICAgPG1hc2sgaWQ9Im1hc2swXzBfMTQ1MSIgc3R5bGU9Im1hc2stdHlwZTphbHBoYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iMCIgeT0iMCIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ij4KICAgICAgICA8Y2lyY2xlIGN4PSIxMiIgY3k9IjEyIiByPSIxMSIgZmlsbD0id2hpdGUiIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIgLz4KICAgIDwvbWFzaz4KICAgIDxnIG1hc2s9InVybCgjbWFzazBfMF8xNDUxKSI+CiAgICAgICAgPHBhdGgKICAgICAgICAgICAgZD0iTTI1LjQxNjcgMC4wMDI4Njg2NUgtMS43MjAyOEMtMi40NjA0MiAwLjAwNjA3MTQ1IC0zLjE2OTA5IDAuMzMyNTY4IC0zLjY5MDM5IDAuOTEwNTMyQy00LjIxMTY4IDEuNDg4NSAtNC41MDI5IDIuMjcwNTggLTQuNDk5OTggMy4wODQ3NFY4LjA0Njk1SDI4LjE5NjRWMy4wODQ3NEMyOC4xOTkzIDIuMjcwNTggMjcuOTA4MSAxLjQ4ODUgMjcuMzg2OCAwLjkxMDUzMkMyNi44NjU1IDAuMzMyNTY4IDI2LjE1NjkgMC4wMDYwNzE0NSAyNS40MTY3IDAuMDAyODY4NjUiCiAgICAgICAgICAgIGZpbGw9IiNCRDJCMzgiIC8+CiAgICAgICAgPHBhdGggZD0iTS00LjUgMTYuMTJIMjguMTk2NFY3Ljk4Mjc5SC00LjVWMTYuMTJaIiBmaWxsPSIjRkNGQkZBIiAvPgogICAgICAgIDxwYXRoCiAgICAgICAgICAgIGQ9Ik0tNC41IDIxLjA0MzVDLTQuNSAyMS44NTQ0IC00LjIwNzEgMjIuNjMyIC0zLjY4NTc4IDIzLjIwNTJDLTMuMTY0NDUgMjMuNzc4NSAtMi40NTc0MiAyNC4xMDAzIC0xLjcyMDMgMjQuMUgyNS40MTY3QzI2LjE1MzggMjQuMTAwMyAyNi44NjA5IDIzLjc3ODUgMjcuMzgyMiAyMy4yMDUyQzI3LjkwMzUgMjIuNjMyIDI4LjE5NjQgMjEuODU0NCAyOC4xOTY0IDIxLjA0MzVWMTYuMTIwMUgtNC41VjIxLjA0MzUiCiAgICAgICAgICAgIGZpbGw9IiMyODMyNjQiIC8+CiAgICA8L2c+Cjwvc3ZnPg==";